module.exports = __webpack_public_path__ + "img/e62040f.jpg";